import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Container from '../../Components/LayoutClient/container.component'
import MissionTemplateForm from './MissionTemplateForm'
import {
    GradientText,
    SubText,
    Wrapper,
} from '../PasserCommande/PasserCommande.styles'
import {getTemplatesForUser,deleteTemplate,createTemplate,updateTemplate} from '../../api/missionTemplate'
import { useSelector } from 'react-redux';
import ActionModal from '../../Components/ValidationModal/ActionModal'
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';


// Styles principaux
const TabContainer = styled.div`
  display: flex;
  margin-bottom: 30px;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
`;

const Tab = styled.button`
  flex: 1;
  padding: 15px 20px;
  border: none;
  background: ${props => props.active ? '#5BBCEA' : 'white'};
  color: ${props => props.active ? 'white' : '#666'};
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  transition: all 0.3s ease;

  &:hover {
    background: ${props => props.active ? '#5BBCEA' : '#f8f9fa'};
  }
`;

const Card = styled.div`
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  margin-bottom: 20px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Label = styled.label`
  font-weight: 600;
  color: #333;
  font-size: 0.95rem;
`;

const Input = styled.input`
  padding: 12px 16px;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }
`;

const Select = styled.select`
  padding: 12px 16px;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-size: 1rem;
  background: white;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }
`;

const TextArea = styled.textarea`
  padding: 12px 16px;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-size: 1rem;
  min-height: 100px;
  resize: vertical;
  font-family: inherit;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }
`;

const Button = styled.button`
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  
  ${props => {
    switch(props.variant) {
      case 'primary':
        return `
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
          }
        `;
      case 'secondary':
        return `
          background: #f8f9fa;
          color: #666;
          border: 2px solid #e1e5e9;
          &:hover {
            background: #e9ecef;
            border-color: #adb5bd;
          }
        `;
      case 'danger':
        return `
          background: #dc3545;
          color: white;
          &:hover {
            background: #c82333;
            transform: translateY(-1px);
          }
        `;
      case 'edit':
        return `
          background: #28a745;
          color: white;
          &:hover {
            background: #218838;
            transform: translateY(-1px);
          }
        `;
      default:
        return `
          background: #6c757d;
          color: white;
          &:hover {
            background: #5a6268;
          }
        `;
    }
  }}
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
`;

const TemplateList = styled.div`
  display: grid;
  gap: 20px;
`;

const TemplateCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0 2px 15px rgba(0,0,0,0.08);
  border-left: 4px solid #5BBCEA;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 25px rgba(0,0,0,0.12);
  }
`;

const TemplateHeader = styled.div`
  display: flex;
  justify-content: between;
  align-items: center;
  margin-bottom: 15px;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start; 
  }
`;

const TemplateName = styled.h3`
  margin: 0;
  color: #333;
  font-size: 1.3rem;
  flex: 1;
`;

const TemplateActions = styled.div`
  display: flex;
  gap: 10px;
`;

const TemplateInfo = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-top: 15px;
`;

const InfoItem = styled.div`
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px;
`;

const InfoLabel = styled.div`
  font-size: 0.85rem;
  color: #666;
  font-weight: 600;
  margin-bottom: 4px;
`;

const InfoValue = styled.div`
  color: #333;
  font-weight: 500;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #666;
`;

const EmptyIcon = styled.div`
  font-size: 4rem;
  margin-bottom: 20px;
  opacity: 0.3;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;
const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  margin-top: 3rem;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
`;


const MissionTemplateManager = () => {
  const [activeTab, setActiveTab] = useState('create');
  const [templates, setTemplates] = useState([]);
  const [editingTemplate, setEditingTemplate] = useState(null);
  const token = useSelector((state) => state.auth.token);
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [loadingAction,setLoadingAction]=useState(null)
  const [loading,setLoading]=useState(false)
  const {t} = useTranslation ()
  const [formData, setFormData] = useState({
    name: '',
    type: '',
    location: '',
    startTime: '',
    endTime: '',
    instructions: '',
    priority: 'medium',
    duration: '',
    requiredSkills: ''
  });
  const openDeleteModal = (template) => {
    setSelectedTemplate(template);
    setDeleteModalIsOpen(true);
  };
  const fetchTemplates = async () => {
    setLoading(true)
    try {
      const response = await getTemplatesForUser(token);
      setTemplates(response.templates);
    } catch (error) {
      toast.error(error.response?.data?.error || error.response?.data?.message || t("error_loading_templates"), {
        style: { fontFamily: 'Montserrat' },
      });
    }finally{
      setLoading(false)
    }
  };
  useEffect(()=>{
    fetchTemplates()
  },[])

  

  const handleSaveTemplate = async (templateData) => {
    try {
      let response;
    
      if (editingTemplate) {
        response = await updateTemplate(editingTemplate._id, templateData, token);
      } else {
        response = await createTemplate(templateData, token);
      }

      toast.success(editingTemplate 
        ? t("template_updated_successfully") 
        : t("template_created_successfully"), {
        style: { fontFamily: 'Montserrat' },
      });

      fetchTemplates();
      setActiveTab('list');
      setEditingTemplate(null);
      
      return response;
    } catch (error) {
      toast.error(
        error.response?.data?.error || 
        error.response?.data?.message || 
        (editingTemplate 
          ? t("error_updating_template") 
          : t("error_creating_template")), 
        { style: { fontFamily: 'Montserrat' } }
      );
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

 

  const handleEdit = (template) => {
    console.log("template",template)
    setFormData(template);
    setEditingTemplate(template);
    setActiveTab('create');
  };

 



  const cancelEdit = () => {
    setEditingTemplate(null);
    setFormData({
      name: '',
      type: '',
      location: '',
      startTime: '',
      endTime: '',
      instructions: '',
      priority: 'medium',
      duration: '',
      requiredSkills: ''
    });
  };
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);
	
		useEffect(() => {
			const checkScreen = () => {
				const width = window.innerWidth;
	
				setIsMobile(width < 768);
	
			};
			checkScreen();
			window.addEventListener('resize', checkScreen);
	
			return () => window.removeEventListener('resize', checkScreen);
		}, []);
   const renderVehicleOption = (option) => {
        switch (option) {
            case "Frigorifique":
                return t("refrigerated");
            case "Bachée":
                return t("tarped");
            case "Hayon":
                return t("liftgate");
            default:
                return option;
        }
    };
    const renderHeavyVehicleType = (type) => {
        switch (type) {
            case "Tracteur+semi":
                return t("tractor_semi");
            case "Semi":
                return t("semi");
            case "Tracteur":
                return t("tractor");
            default:
                return type;
        }
    };
    const renderLightVehicleType = (type) => {
        switch (type) {
            case "Break":
                return t("break");
            case "Fourgon":
                return t("fourgon");
            case "Camion":
                return t("camion");
            default:
                return type;
        }
    };
 
  return (
    <Container>
     <Wrapper>
        
        <GradientText style={{fontSize: isMobile? '2rem' : '2.5rem' , textAlign: 'center'
        }}>{t("template_manager").toUpperCase()}</GradientText>
        <SubText>
        {t("create_and_manage_templates")}
        </SubText>
       <div
						style={{
							width: '100%',
							fontFamily: 'Montserrat',
							marginBottom: 5,
              marginTop:'2rem'
						}}
					>
      <TabContainer>
        <Tab 
          active={activeTab === 'create'} 
          onClick={() => setActiveTab('create')}
        >
          {editingTemplate ? t("edit_template") : t("create_template")}
        </Tab>
        <Tab 
          active={activeTab === 'list'} 
          onClick={() => setActiveTab('list')}
        >
          {t("my_templates")} ({templates.length})
        </Tab>
      </TabContainer>

      {activeTab === 'create' && (
        <MissionTemplateForm
        formData={formData}
        handleInputChange={handleInputChange}
        cancelEdit={() => {
            setEditingTemplate(null);
            setFormData({});
            setActiveTab('list');
        }}
        editingTemplate={editingTemplate}
        onSave={handleSaveTemplate} 
    />
      )}

      {activeTab === 'list' && (
        <div style={{marginBottom:"2rem"}}>
          {templates.length === 0 ? (
            <Card>
              <EmptyState>
                <EmptyIcon>📋</EmptyIcon>
                <h3>{t("no_templates_created")}</h3>
                <p>{t("start_creating_first_template")}</p>
                <Button 
                  variant="primary" 
                  onClick={() => setActiveTab('create')}
                  style={{ marginTop: '20px' }}
                >
                  {t("create_first_template")}
                </Button>
              </EmptyState>
            </Card>
          ) : (
            <TemplateList>
              {templates.map(template => (
                <TemplateCard key={template.id}>
                  <TemplateHeader>
                    <TemplateName>{template.name}</TemplateName>
                    <TemplateActions>
                      <Button 
                        variant="edit" 
                        onClick={() => handleEdit(template)}
                        style={{ fontSize: '0.9rem', padding: '8px 16px' }}
                      >
                        {t("edit")}
                      </Button>
                      <Button 
                        variant="danger" 
                        onClick={() => openDeleteModal(template)}
                        style={{ fontSize: '0.9rem', padding: '8px 16px' }}
                      >
                        {t("delete")}
                      </Button>
                    </TemplateActions>
                  </TemplateHeader>

                  <TemplateInfo>
                  <InfoItem>
                <InfoLabel>{t("start_address")}</InfoLabel>
                <InfoValue>{template?.adresse_debut?.label}</InfoValue>
              </InfoItem>
              
              <InfoItem>
                <InfoLabel>{t("end_address")}</InfoLabel>
                <InfoValue>{template?.adresse_fin?.label}</InfoValue>
              </InfoItem>
              
                  <InfoItem>
                  <InfoLabel>{t("mileage")}</InfoLabel>
                  <InfoValue>{template?.kilometrage} km</InfoValue>
                  </InfoItem>

                <InfoItem>
                <InfoLabel>{t("loading_time")}</InfoLabel>
                <InfoValue>{template?.taux_chargement} min</InfoValue>
                </InfoItem>
                

                <InfoItem>
                <InfoLabel>{t("delivery")}</InfoLabel>
                <InfoValue>{template?.livraison}</InfoValue>
              </InfoItem>
              <InfoItem>
                <InfoLabel>{t("load_type")}</InfoLabel>
                <InfoValue>
                  {template?.nature_chargement === 'vrac' ? t("bulk") : t("pallet")}
                </InfoValue>
              </InfoItem>
              <InfoItem>
                <InfoLabel>{t("transport_type")}</InfoLabel>
                <InfoValue>{template?.type_transport === 'Véhicule léger' ? t("vehicle_type2") : t("vehicle_type1")}</InfoValue>
              </InfoItem>
              <InfoItem>
                <InfoLabel>{t("vehicle")}</InfoLabel>
                <InfoValue>
                  {template?.type_transport === 'Véhicule léger'
                    ? renderLightVehicleType(template?.type_transport_details)
                    : renderHeavyVehicleType(template?.vehicule_poids_lourds)}
                </InfoValue>
              </InfoItem>

              <InfoItem>
                <InfoLabel>Options</InfoLabel>
                <InfoValue>
                  {template.type_transport === 'Véhicule léger'
                    ? template?.options_vehicule_leger.map(option => renderVehicleOption(option)).join(', ')
                    : template?.options_poids_lourds.map(option => renderVehicleOption(option)).join(', ')}
                </InfoValue>
              </InfoItem>
              
                    
               </TemplateInfo>

                  <div style={{ 
                    marginTop: '15px', 
                    fontSize: '0.85rem', 
                    color: '#666',
                    borderTop: '1px solid #e9ecef',
                    paddingTop: '10px'
                  }}>
                    {t("created_on")} {new Date(template.createdAt).toLocaleDateString('fr-FR')}
                    {template.updatedAt && (
                      <span> • {t("modified_on")} {new Date(template.updatedAt).toLocaleDateString('fr-FR')}</span>
                    )}
                  </div>
                </TemplateCard>
              ))}
            </TemplateList>
          )}
        </div>
      )}
       <ActionModal
              isOpen={deleteModalIsOpen}
              onRequestClose={()=>setDeleteModalIsOpen(false)}
              title={t("delete_template")}
              message={t("delete_template_confirmation")}
              onConfirm={async () => {	
                setLoadingAction(true)
              try {
                const res= await deleteTemplate(selectedTemplate._id, token);

              toast.success(res?.message || t("template_deleted_successfully"), {
              style: {
                fontFamily: 'Montserrat',
              },
            })
            fetchTemplates()

              } catch (error) {
                toast.error(
                  error.response?.data.message || t("error_deleting_template"),
                  {
                    style: {
                      fontFamily: 'Montserrat',
                    },
                  }
                )
              }finally {
                setLoadingAction(false)
                setDeleteModalIsOpen(false)
              }	
              }}
              
              onCancel={()=>setDeleteModalIsOpen(false)}
              isLoading={loadingAction}
            />
       </div>
       
            </Wrapper>

    </Container>
  );
};

export default MissionTemplateManager;